<template>
  <authenticated-layout :back-route="{
                          name: 'cohortDashboard',
                          params: { cohortId, institutionId, tab: 'students' }
                        }"
                        :breadcrumbs="breadcrumbItems">

    <user-detail-content
      :user-id="userId"
      :tenant-id="tenantId"
      :institution-id="institutionId"
      :cohort-id="cohortId"
      route-name="cohortUserDetail"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import UserDetailContent from "@/components/Users/UserDetailContent.vue";
import {useGlobalStore} from "@/store";
import {Cohort} from "@YenzaCT/sdk";
import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";

const route = useRoute();
const store = useGlobalStore();
const { executeApi } = useApiCall();

const userId = computed(() => route.params.userId as string);
const tenantId = computed(() => route.params.tenantId as string);
const institutionId = computed(() => route.params.institutionId as string);
const cohortId = computed(() => route.params.cohortId as string);
const canAccessSpecificTenant = store.canAccessSpecificTenant(`${route.params.tenantId}`);
const cohort = ref<Cohort>();

const breadcrumbItems = computed(() => [
  { text: "My Schools", to: { name: "schoolsDashboard" } },
  { text: cohort.value?.tenantMeta?.title || "",
    to: canAccessSpecificTenant ? { name: "schoolsDashboardWithTenant",
      params: { tenantId: cohort.value?.tenant } } : {
      name: "schoolsDashboardWithoutTenant"
    }},
  {
    text: cohort.value?.title || "Institution",
    to: { name: "institutionDashboard", params: { institutionId: institutionId.value } }
  },
  { text: "User Details" }
]);

async function fetchCohort() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.cohort.get(cohortId.value);
    return response.data;
  });
  if (result) {
    cohort.value = result;
  }
}

onMounted(async () => {
  await fetchCohort();
});
</script>
